const errorCodes = {
  UserAccountExpiredException: 52,
  TokenMalformedException: 61,
  TokenExpiredException: 62,
  TokenInvalidException: 63,
  InvalidRequestDataException: 102,
  InvalidBusinessProfileRequested: 112,
  ForbiddenBusinessProfileRequested: 113,
  Unauthorized: 401,
  InvalidOtpException: 57,
  ExpiredOtpException: 71,
  InvalidHashkeyRequested: 60,
  EntityAlreadyExistsError: 101,
  EntityDoesNotExistException: 104,
  EntityNotFoundInCacheException: 308,
  InvalidLoginCredentials: 51,
  ForbiddenPortalRequested: 56,
  InvalidPortalRequestedException: 55,
  EmailAlreadyVerifiedError: 65,
  OtpAlreadyGeneratedException: 800,
  OtpVerificationAttemptsExceededException: 801,
  PasswordExpiredException: 74,
  OldPasswordException: 75,
  RefreshTokenExpiredException: 76,
  EmailNotVerified: 64,
  InvalidCustomAttributeOperationException: 1005,

  // http status codes
  HttpEntityNotFound: 404,
  HttpBadRequest: 400,
  HttpUnauthorized: 401,
  HttpForbidden: 403
}

export default errorCodes
